/* Lifecycle callbacks also cover Shopify section replacements. No commerce state. */
(() => {
  const tag = 'roulette-variant-storytelling';
  if (!window.customElements || customElements.get(tag)) return;

  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => this.revealAll();
      this.motion.addEventListener('change', this.onMotionChange);
      if (this.motion.matches || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('is-pending');
          this.observer.unobserve(entry.target);
        });
      }, { threshold: 0.08 });

      this.querySelectorAll('[data-story-reveal]').forEach((element) => {
        // Never hide content already visible, including restored scroll positions.
        if (element.getBoundingClientRect().top < window.innerHeight) return;
        element.classList.add('is-pending');
        this.observer.observe(element);
      });
    }

    revealAll() {
      this.observer?.disconnect();
      this.querySelectorAll('.is-pending').forEach((element) => element.classList.remove('is-pending'));
    }

    disconnectedCallback() {
      this.revealAll();
      this.motion?.removeEventListener('change', this.onMotionChange);
    }
  });
})();
